import React from 'react';

/**
 * Warning icon SVG — replaces @atlaskit/icon WarningIcon.
 *
 * @param {Object} props - Component props.
 * @param {string} props.label - Accessible label for the icon.
 * @returns {ReactElement}
 */
const WarningIconSVG = ({ label }) => (
    <svg
        aria-label = { label }
        className = 'custom-title-icon__svg'
        fill = 'currentColor'
        height = '20'
        role = 'img'
        viewBox = '0 0 24 24'
        width = '20'
        xmlns = 'http://www.w3.org/2000/svg'>
        <title>{label}</title>
        <path d = 'M12 2.5L1.5 21h21L12 2.5zm0 3l8.5 14.5h-17L12 5.5zm-1 5v5a1 1 0 002 0v-5a1 1 0 00-2 0zm0 7.5a1 1 0 102 0 1 1 0 00-2 0z' />
    </svg>
);

export default WarningIconSVG;
